export default {
  from: 'fra',
  select: 'Vælg',
  deal: 'tilbud',
  deals: 'tilbud',
  total: 'totalt',
  total_fr: '',
  pp: 'pp',
}
